function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */


import Base from './base';
import { popRootKey } from '../util.js';

var BulkEdit = /*#__PURE__*/function (_Base) {
  _inheritsLoose(BulkEdit, _Base);

  function BulkEdit() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = BulkEdit.prototype;

  _proto.initialize = function initialize(opts) {
    if (opts == null) {
      opts = {};
    }

    this.users = opts.users;
    delete opts.users; // We don't want this sent in the POST body.

    return this.unset('users');
  };

  _proto.parse = function parse(json) {
    // add the groups last after the groups have been set up
    var group, user;

    for (var _i = 0, _Array$from = Array.from(json.polls); _i < _Array$from.length; _i++) {
      var obj = _Array$from[_i];
      var attrs = popRootKey(obj);
      user = this.users.get(attrs.owner_id);
      group = user.groups.get(attrs.group_id);

      if (user != null) {
        user.polls.add(obj, {
          merge: true,
          parse: true
        });
      }
    }

    for (var _i2 = 0, _Array$from2 = Array.from(json.updated_groups); _i2 < _Array$from2.length; _i2++) {
      obj = _Array$from2[_i2];
      user = this.users.get(popRootKey(obj).owner_id);

      if (user != null) {
        user.groups.add(obj, {
          merge: true,
          parse: true
        });
      }
    }

    for (var _i3 = 0, _Array$from3 = Array.from(json.new_groups); _i3 < _Array$from3.length; _i3++) {
      obj = _Array$from3[_i3];
      user = this.users.get(popRootKey(obj).owner_id);
      group = user != null ? user.groups.add(obj, {
        merge: true,
        parse: true
      }) : undefined; // tell the view that this is already loaded

      group.markAsLoaded();
    }

    for (var _i4 = 0, _Array$from4 = Array.from(json.deleted_groups); _i4 < _Array$from4.length; _i4++) {
      obj = _Array$from4[_i4];
      obj = popRootKey(obj);
      user = this.users.get(obj.owner_id);

      if (user != null) {
        user.groups.remove(user != null ? user.groups.get(obj.id) : undefined);
      }
    }

    return json;
  };

  _createClass(BulkEdit, [{
    key: "url",
    get: function get() {
      return '/my/polls/multi_edit';
    }
    /*
     * Needed so that backbone doesn't think this model is persistent.
     * Without this it will do a PUT rather than a POST.
     */

  }, {
    key: "idAttribute",
    get: function get() {
      return '_id';
    }
  }]);

  return BulkEdit;
}(Base);

export { BulkEdit as default };